<template>
    <modal :title="$t(title)" :visible.sync="isShowDialog" :appendToBody="true" width="1200px">
        <publicContent v-bind="$attrs" ref="public" />

        <div slot="footer">
            <el-button type="primary" @click="isShowDialog = false">{{ $t('public.btn_close') }}</el-button>
            <el-button type="primary" @click="handleSave">{{ $t('public.btn_confirm') }}</el-button>
        </div>
    </modal>
</template>

<script>
import { alarmAddAlarmTrigger } from '@/api/modules/alarm.js'
import publicContent from './PublicContent.vue'

export default {
  props: ['title', 'isShowAdd', 'scopeId'],
  components: {
    publicContent
  },
  computed: {
    isShowDialog: {
      get: function () {
        return this.isShowAdd
      },
      set: function (val) {
        this.$emit('update:isShowAdd', val) // 可以优化成model  或者minx
      }
    }
  },
  methods: {
    resetFn () {
      this.$refs.public.resetFn()
    },
    async handleSave () {
      const flag = await this.$refs.public.justify()
      const flag2 = await this.$refs.public.$refs.level.justify()
      if (!flag || !flag2) return
      const queryParam = this.$refs.public
      const { name, reason, type, repeatCount, repeatInterval, intervalUnit, alarmTriggerTimeList, strategy } = queryParam.dioForm
      const alarmTime = []
      alarmTriggerTimeList.map(item => {
        alarmTime.push({
          alarmTime: item.alarmTime,
          alarmTimeList: item.alarmTimeList.map(opt => {
            return {
              endTime: opt.time[1],
              startTime: opt.time[0]
            }
          })
        })
      })
      const query = {
        sceneId: this.scopeId,
        name,
        reason: reason.join(','),
        type,
        repeatCount,
        repeatInterval,
        intervalUnit,
        alarmTriggerTimeList: alarmTime,
        strategy
      }
      const level = queryParam.$refs.level.alarmTriggerHierarchyList
      let alarmTriggerHierarchyList = []
      alarmTriggerHierarchyList = level.map((item, index) => {
        item.alarmContactList = item.dioForm.tableData.map(opt => {
          return {
            // id: !opt.name ? opt.userId : null,
            name: opt.name,
            alarmWay: opt.alarmWay,
            phone: opt.phone,
            email: opt.email
          }
        })

        item.abnormalDelayList = item.abnormalDelayList.map(row => {
          return {
            type: row.type,
            delayNum: row.delayNum,
            unit: row.unit
          }
        })

        return {
          name: item.name,
          sort: index + 1 + '',
          alarmContactList: item.alarmContactList,
          abnormalDelayList: item.abnormalDelayList,
          sign: queryParam.$refs.level.userShow ? 1 : 0
        }
      })
      query.alarmTriggerHierarchyList = alarmTriggerHierarchyList
      alarmAddAlarmTrigger(query).then(async ({ state }) => {
        await this.$resultHandle(state)
        this.isShowDialog = false
        this.$emit('getAgainFn')
      })
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .el-input-group__append {
    background-color: #fff;
}
</style>
